<template>
  <div class="dataCenter">
    <div class="data-top-item">
      <i class="el-icon-key"></i>
      账号信息
      <div>
        appKey：<span class="appKey">{{ userInfo.appKey }}</span>
        <button class="copy" @click="copy">复制</button>
      </div>
      <div>
        手机号&nbsp;：<span class="username">{{ userInfo.username }}</span>
      </div>
    </div>

    <div class="statis">
      <div class="titleName">接口调用趋势</div>
      <div class="date">
        <el-date-picker
          v-model="value"
          type="daterange"
          align="center"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="getUserInterfaceStatis"
        >
        </el-date-picker>
      </div>

      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
/**
 * 1.安装依赖 yarn add echarts vue-echarts
 * 2.按需导入组件和图表类型
 * 3.注册所需的组件
 *  */
import * as echarts from 'echarts/core'
import { BarChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent
} from 'echarts/components'
import { LabelLayout, UniversalTransition } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'

import { getUserInterfaceStatis } from '@/api/common'

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LegendComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
])
export default {
  data () {
    return {
      statisList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate (time) {
          const yesterday = new Date()
          yesterday.setDate(yesterday.getDate() - 1)
          return time.getTime() > yesterday.getTime() // 禁止选择昨天以后的日期
        }
      },
      value: this.getDefaultDateRange()
    }
  },
  methods: {
    async copy () {
      if (navigator && navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(this.userInfo.appKey)
          this.$toast.success('文本已成功复制到剪切板')
        } catch (err) {
          this.$toast.error('复制失败: ' + err.message)
        }
      } else {
        this.$toast.error('当前环境不支持剪贴板操作')
      }
    },
    async getUserInterfaceStatis () {
      const statisList = await getUserInterfaceStatis(this.value[0], this.value[1])
      this.statisList = statisList.data

      this.chart.setOption({
        xAxis: {
          data: this.statisList.map((item) => item.time)
        },
        series: [
          {
            data: this.statisList.map((item) => item.count)
          }
        ]
      })
    },
    getDefaultDateRange () {
      const end = new Date()
      end.setDate(end.getDate() - 1) // 昨天
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      return [this.formatDate(start), this.formatDate(end)]
    },
    formatDate (date) {
      const y = date.getFullYear()
      const m = (date.getMonth() + 1).toString().padStart(2, '0')
      const d = date.getDate().toString().padStart(2, '0')
      return `${y}-${m}-${d}`
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted () {
    // 初始化图表
    this.chart = echarts.init(this.$refs.chart)
    const option = {
      // tooltip 配置项，用于显示鼠标悬停时的数据提示
      tooltip: {
        trigger: 'axis', // 触发类型为坐标轴触发，适用于柱状图等
        axisPointer: {
          // 坐标轴指示器配置项
          type: 'shadow' // 默认为直线，可选为'shadow'阴影指示器
        }
      },
      xAxis: {
        data: []
      },
      yAxis: {},
      series: [
        {
          name: '调用次数',
          data: [],
          type: 'bar',
          // 柱条的样式可以通过 series.itemStyle 设置
          itemStyle: {
            // 柱条的颜色
            color: '#95cc75',
            borderWidth: 1,
            borderType: 'solid',
            borderColor: '#73c0de'
          },
          // 将 barWidth 设为 '20%'，表示每个柱条的宽度就是类目宽度的 20%
          barWidth: '60%'
        }
      ]
    }
    this.chart.setOption(option)
  },
  created () {
    this.getUserInterfaceStatis()
  }
}
</script>

<style lang="less" scoped>
.dataCenter {
  width: 100%;
  padding: 30px 40px;
  .data-top-item {
    width: 32%;
    padding: 20px;
    box-shadow: 0 3px 10px 0 rgba(123, 119, 119, 0.1607843137254902);
    border-radius: 6px;
    .appKey {
      display: inline-block;
      padding: 4px 4px;
      text-align: center;
      margin-top: 10px;
      color: #a26363;
      font-size: 12px;
    }
    .copy {
      color: #fff;
      cursor: pointer;
      background-color: rgb(221, 177, 58);
      border: none;
      padding: 2px 5px;
      border-radius: 2px;
      vertical-align: middle;
      margin-left: 10px;
      font-size: 12px;
    }
    .username {
      color: #a26363;
      padding: 4px 4px;
    }
  }
  .statis {
    padding: 20px;
    box-shadow: 0 3px 10px 0 rgba(123, 119, 119, 0.1607843137254902);
    border-radius: 6px;
    margin-bottom: 30px;
    margin-top: 30px;
    .date {
      margin: 10px auto;
      max-width: 350px;
    }
    .chart {
      width: 100%;
      height: 400px;
    }
    .titleName {
      border-bottom: 1px solid #e3dede;
      padding-bottom: 15px;
      font-size: 16px;
      font-weight: 600;
      color: #515a6e;
    }
  }
}
</style>
